import { Routes, Route } from "react-router-dom";
import Blog from "../../Pages/Blog";
import Gallery from "../../Pages/Gallery/Gallery";
import ProtectedRoute from "./ProtectedRoute";
import Service from "../../Pages/Service";
import Login from "../../Pages/Auth/Login/Login";
import PageNotFound from "../PageNotFound/PageNotFound";
import Layout from "../layout/Layout/Layout";
import Signup from "../../Pages/Auth/Signup/Signup";
import AddBlog from "../../Pages/Blog/AddBlog/AddBlog";
import UpdateBlog from "../../Pages/Blog/UpdateBlog/UpdateBlog";
import Dashboard from "../../Pages/Dashboard/Dashboard";
import Forgetpassword from "../../Pages/Auth/Forgetpassword/Forgetpassword";
import CustomGalleryList from "../../Pages/Custompage/Gallery/GalleryList";

import AddProductCategory from "../../Pages/Products/AddProductCategory/AddProductCategory";
import UpdateProductListing from "../../Pages/Products/UpdateProductListing/UpdateProductListing";
import AddService from "../../Pages/Service/AddService/AddService";
import ServiceListing from "../../Pages/Service/ServiceListing/ServiceListing";
import UpdateService from "../../Pages/Service/UpdateService/UpdateService";
// import AddProductDetails from "../../Pages/Products/AddProductDetails/AddProductDetails";
// import ProductSpecification from "../../Pages/Products/AddProductSpecification/ProductSpecification";
import ProductSpecification from "../../Pages/Products/AddProductSpecification/ProductSpecification";
import AboutUs from "../../Pages/AboutUs/AboutUs";
import Home from "../../Pages/Home/Home";
import ProductTypeListing from "../../Pages/Products/ProductType/CategoryProduct";
import AddProductType from "../../Pages/Products/ProductType/AddProductType";
import UpdateProductType from "../../Pages/Products/ProductType/UpdateProductType";
import ProductTypeSpecification from "../../Pages/Products/ProductType/ProductTypeSpecification";
import ProductTypeBenifits from "../../Pages/Products/ProductType/ProductTypeBenifits";
import GalleryList from "../../Pages/Gallery/GalleryList";
import UpdateGallery from "../../Pages/Gallery/UpdateGallery";
import Menu from "../../Pages/Menu/Menu";
import AddMenu from "../../Pages/Menu/AddMenu";
import Attribute from "../../Pages/Attribute/Attribute";
import AddAttribute from "../../Pages/Attribute/AddAttribute";
import UpdateAttribute from "../../Pages/Attribute/UpdateAttribute";

import Category from "../../Pages/Products/Category/Category";
import CategoryProduct from "../../Pages/Products/ProductType/CategoryProduct";
import AddProductBenifit from "../../Pages/Products/ProductBenifit/AddProductBenifit";
import CategorySpecification from "../../Pages/Products/CategorySpecification/AddCategorySpecification";
import Faq from "../../Pages/Faq/Faq";
import AddFaq from "../../Pages/Faq/AddFaq";
import AddMileStone from "../../Pages/AddMileStone/AddMileStone";
import MagnusTeam from "../../Pages/MagnusTeam/MagnusTeam";
import Contactlist from "../../Pages/Contactlist/Contactlist";
import { Navigate } from "react-router-dom";
import Custompage from "../../Pages/Custompage/Custompage";
import CustomPageDetails from "../../Pages/Custompage/Custompagedetails";
import UpdateCustomPage from "../../Pages/Custompage/Updatecustompage";
import FeaturesList from "../../Pages/Custompage/Features/FaeturesList";
import AddFeatures from "../../Pages/Custompage/Features/AddFeatures";
import UpdateFeature from "../../Pages/Custompage/Features/UpdateFeature";
import AddCustomPageGallery from "../../Pages/Custompage/Gallery/AddCustomPageGallery";
import UpdateCustomPageGallery from "../../Pages/Custompage/Gallery/UpdateCustomGallery";

const AppRoutes = ({ setLoading }) => {
  return (
    <Routes>
      <Route path="/signup" element={<Signup />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forget-password" element={<Forgetpassword />} />



      <Route element={<ProtectedRoute />}>
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="/menu" replace />} />
          <Route path="home" element={<Home />} />
          <Route path="blog" element={<Blog />} />
          <Route path="menu" element={<Menu />} />
          <Route path="add-menu" element={<AddMenu />} />
          <Route path="update-menu/:id" element={<AddMenu />} />
          <Route path="add-gallery" element={<Gallery setLoading={setLoading} />} />
          <Route path="gallery" element={<GalleryList setLoading={setLoading} />} />
          <Route path="update-gallery/:id" element={<UpdateGallery setLoading={setLoading} />} />
          <Route path="product-benifit/:id" element={<AddProductBenifit />} />
          <Route path="category-specification/:id" element={<CategorySpecification />} />
          <Route path="category" element={<Category />} />
          <Route path="add-product-category" element={<AddProductCategory />} />
          <Route path="update-product-category/:id" element={<UpdateProductListing setLoading={setLoading} />} />
          <Route path="product-specification/:id" element={<ProductSpecification setLoading={setLoading} />} />
          {/* <Route path="product-type-listing/:id" element={<Category />} /> */}
          <Route path="add-product/:id" element={<AddProductType />} />
          <Route path="update-product/:id" element={<UpdateProductType />} />
          <Route path="product-type-specification/:id" element={<ProductTypeSpecification setLoading={setLoading} />} />
          <Route path="product-type-benifit/:id" element={<ProductTypeBenifits setLoading={setLoading} />} />
          <Route path="category/:id" element={<CategoryProduct setLoading={setLoading} />} />
          <Route path="about" element={<AboutUs />} />
          <Route path="add-blog" element={<AddBlog />} />
          <Route path="update-blog/:id" element={<UpdateBlog />} />
          <Route path="services" element={<Service />} />
          <Route path="add-service" element={<AddService />} />
          <Route path="update-service/:id" element={<UpdateService />} />
          <Route path="attribute" element={<Attribute />} />
          <Route path="add-attribute" element={<AddAttribute />} />
          <Route path="update-attribute/:id" element={<UpdateAttribute />} />
          <Route path="faq" element={<Faq />} />
          <Route path="add-faq" element={<AddFaq />} />
          <Route path="magnus-team" element={<MagnusTeam />} />
          <Route path="contact-list" element={<Contactlist />} />
          <Route path="milestone" element={<AddMileStone />} />
          <Route path="update-faq/:id" element={<AddFaq />} />
          <Route path="/add-custompage/:id" element={<Custompage />} />
          <Route path="/custom-page/:id" element={<CustomPageDetails />} />
          <Route path="/update-custom-page/:id" element={<UpdateCustomPage />} />
          <Route path="/features-list/:id" element={<FeaturesList />} />
          <Route path="/add-feature/:id" element={<AddFeatures />} />
          <Route path="/updatecustompage-feature/:id" element={<UpdateFeature />} />
          <Route path="/custom-gallerylist/:id" element={<CustomGalleryList />} />
          <Route path="/add-custom-gallery/:id" element={<AddCustomPageGallery />} />
          <Route path="/update-custom-gallery/:id" element={<UpdateCustomPageGallery />} />

        </Route>
      </Route>
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default AppRoutes;